import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import ServicesOverview from '../home/components/ServicesOverview';
import { COMPANY, SERVICE_AREAS } from '../../mocks/siteData';

const faqs = [
  {
    q: 'Who provides home remodeling near me in the Bay City area?',
    a: 'Bay City Remodeling & Bathrooms LLC serves homeowners throughout Brandon, Riverview, Tampa, Valrico, and 20+ surrounding communities with kitchen, bathroom, and full-home remodeling solutions built around quality and precision.',
  },
  {
    q: 'What areas does Bay City Remodeling serve?',
    a: 'We serve homeowners across Brandon, Riverview, Seffner, Valrico, Tampa, Plant City, Apollo Beach, Ruskin, Fish Hawk, Temple Terrace, and all surrounding areas within the greater Bay City corridor.',
  },
  {
    q: 'How do I schedule a consultation in my area?',
    a: 'Simply call us at 813-362-0114 or submit our online consultation form. We come to your home, review the space, and provide a clear scope and timeline before any commitment.',
  },
  {
    q: 'Do you serve all of Hillsborough County?',
    a: 'Yes. Bay City Remodeling serves homeowners throughout Hillsborough County and select surrounding areas. If you\'re unsure whether we serve your location, call us and we\'ll confirm immediately.',
  },
];

export default function NearMePage() {
  return (
    <div className="font-sans">
      <Navbar />

      {/* 1. Hero */}
      <section
        className="relative min-h-[92vh] w-full flex items-end overflow-hidden"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/77662bfd0a1b2f5374ea9c6cc3f8c127.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 40%',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-stone-950/55 to-stone-900/10" />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950/80 via-stone-950/35 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-stone-950 to-transparent" />

        <div className="relative z-10 w-full px-6 lg:px-16 xl:px-24 pb-20 pt-40">
          <div className="max-w-4xl">
            <p className="text-accent text-xs font-semibold tracking-[0.2em] uppercase mb-5">Service Areas</p>
            <div className="lg:pl-7 relative">
              <div className="absolute left-0 top-0 w-[2px] h-full bg-gradient-to-b from-accent via-accent/50 to-transparent hidden lg:block" />
              <h1 className="font-serif text-[50px] md:text-[66px] lg:text-[78px] text-white leading-[1.0] tracking-tight mb-6" style={{ letterSpacing: '-0.02em' }}>
                Serving Homeowners Throughout the Bay City Area
              </h1>
            </div>
            <p className="text-white/60 text-base md:text-lg mb-10 leading-relaxed max-w-2xl">
              Bay City Remodeling provides premium kitchen, bathroom, and full-home remodeling services across Brandon, FL and 23 surrounding communities — with deep local knowledge and a 5.0-star reputation.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/about"
                className="group inline-flex items-center gap-3 bg-accent hover:bg-accent-dark text-white font-semibold px-8 py-4 rounded-lg transition-colors whitespace-nowrap text-sm"
              >
                Request a Consultation
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1 text-xs" />
                </div>
              </Link>
              <a
                href={`tel:${COMPANY.phoneFull}`}
                className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-white/50 bg-white/5 text-white font-medium px-8 py-4 rounded-lg transition-colors whitespace-nowrap text-sm"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-accent" />
                </div>
                {COMPANY.phone}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Services Overview */}
      <ServicesOverview />

      {/* 4. AI Answer Block */}
      <AIAnswerBlock
        question="Who Provides Remodeling Services Near Me in the Bay City Area?"
        answer="Bay City Remodeling & Bathrooms LLC provides kitchen, bathroom, and full-home remodeling services to homeowners throughout Brandon, FL and 23+ surrounding communities. With 18+ years of local experience, the company delivers high-quality renovations tailored to each home and homeowner."
        bullets={[
          'Serving Brandon, Riverview, Tampa, Valrico, Seffner, and 18+ more communities',
          'Kitchen remodeling, bathroom remodeling, full home renovations, and interior upgrades',
          '18+ years of local experience in the Bay City area',
          '5.0-star rated with 58+ verified homeowner reviews',
          'Free in-home consultations with no obligation',
        ]}
      />

      {/* 5. Process */}
      <ProcessSection />

      {/* 6. Why Choose Us */}
      <WhyChooseUs />

      {/* 7. Service Areas — large map + full city grid */}
      <section className="bg-white py-32 px-6 lg:px-16 xl:px-24">
        <div className="max-w-6xl mx-auto">
          <div className="mb-14">
            <p className="text-accent text-xs font-semibold tracking-[0.2em] uppercase mb-4">All Service Areas</p>
            <h2 className="font-serif text-4xl lg:text-[52px] text-stone-900 leading-tight mb-4" style={{ letterSpacing: '-0.02em' }}>Communities We Serve</h2>
            <p className="text-stone-500 text-sm max-w-2xl">
              Bay City Remodeling brings the same dedication, craftsmanship, and accountability to every home in every community we serve across Hillsborough County.
            </p>
          </div>

          {/* Full Map */}
          <div className="rounded-2xl overflow-hidden mb-12 h-[460px] border border-stone-100">
            <iframe
              src={COMPANY.mapEmbed}
              width="100%"
              height="100%"
              loading="lazy"
              allowFullScreen
              title="Bay City Remodeling Service Areas Map"
              className="border-0 w-full h-full"
            />
          </div>

          {/* City Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {SERVICE_AREAS.map((area) => (
              <Link
                key={area.slug}
                to={`/near-me/${area.slug}`}
                className="group flex items-center gap-3 bg-[#FAF8F4] hover:bg-accent rounded-xl px-4 py-3.5 transition-all duration-200"
              >
                <div className="w-6 h-6 rounded-md bg-accent/15 group-hover:bg-white/20 flex items-center justify-center flex-shrink-0 transition-colors">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-map-pin-2-line text-accent group-hover:text-white text-xs transition-colors" />
                  </div>
                </div>
                <span className="text-stone-700 group-hover:text-white text-sm font-medium transition-colors">{area.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 8. Testimonials */}
      <TestimonialsSection />

      {/* 9. FAQ */}
      <FAQSection faqs={faqs} title="Service Area Questions Answered" />

      {/* 10. Final CTA */}
      <FinalCTA
        title="Serving Your Community With Pride"
        subtitle="Wherever you are in the Bay City area, we bring the same dedication, craftsmanship, and accountability to every project."
      />

      <Footer />
    </div>
  );
}
